import * as yup from 'yup';
import {containsDangerousScript} from '@/utils/validation/sanitization';

yup.addMethod(yup.string, 'noDangerousContent', function (message: string) {
  return this.test('no-dangerous-content', message, function (value) {
    if (!value) return true;
    return !containsDangerousScript(value);
  });
});
